import useTranslate from 'app/i18n/useTranslate';

const useConstants = () => {
    const t = useTranslate('navigation');

    return {
        ACCOUNT: t('account'),
        AIR: t('air'),
        CHEMICALS: t('chemicals'),
        CONNECTIONS: t('connections'),
        DATA: t('data'),
        HELP: t('help'),
        HOME: t('home'),
        MAINT: t('maint'),
        REPORTS: t('reports')
    };
};

export default useConstants;
